import React, { createContext, useState } from "react";
import { useTranslation } from "react-i18next";
import "./i18n"; // Ensure i18n is imported

export const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
    const { i18n } = useTranslation();
    const [lang, setLang] = useState(i18n.language || "en");

    const changeLanguage = (newLang) => {
        setLang(newLang);
        i18n.changeLanguage(newLang);
    };

    return (
        <LanguageContext.Provider value={{ lang, changeLanguage }}>
            {children}
        </LanguageContext.Provider>
    );
};
